import { FundsResponse } from './api/funds';
import { BankAccountStatus } from 'src/helpers/api/paymentDetails';
import isAfter from 'date-fns/is_after';
import isPast from 'date-fns/is_past';

export const fundsStatusWhiteList = [
  'NoFunds',
  'PreviousWithdrawalProcessing',
  'CanWithdraw',
  'NotAvailableYet',
  'ProjectNotActive',
  'ProjectNotReviewed',
  'ProjectNotVerified',
];

export const getFundsStatus = ({
  amountRaised,
  finishedAt,
  fundsResponse,
  bankAccountStatus,
}: {
  amountRaised: number;
  finishedAt: string;
  fundsResponse: FundsResponse;
  bankAccountStatus?: BankAccountStatus;
}) => {
  const hasPageClosed = isPast(finishedAt);

  if (hasPageClosed && amountRaised > 0) {
    const automaticWithdraw = fundsResponse.withdrawals.find(withdrawal =>
      isAfter(withdrawal.dateRequested, finishedAt)
    );

    if (automaticWithdraw && automaticWithdraw.status === 'Processing') {
      return 'FinalWithdrawalProcessing';
    }

    const totalAmountWithdrawn = fundsResponse.withdrawals
      .filter(withdrawal => withdrawal.status === 'Complete')
      .reduce((total, withdrawal) => total + withdrawal.grossAmount, 0);

    if (totalAmountWithdrawn >= amountRaised) {
      return 'FinalWithdrawalComplete';
    }

    return 'FinalDonationsSettling';
  }

  if (fundsResponse.status !== 'ProjectNotVerified' && amountRaised === 0) {
    return 'NoFirstDonation';
  }

  if (bankAccountStatus === BankAccountStatus.New) {
    return 'BankAccountDetailsPending';
  }

  if (fundsStatusWhiteList.includes(fundsResponse.status)) {
    return fundsResponse.status;
  }

  throw new Error('Status not available');
};



// WEBPACK FOOTER //
// ./src/helpers/funds.ts